
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.ibadansouthanglicandiocese.org.ng/api/v1/',
  timeout: 10000,
});

// API endpoints
export const apiEndpoints = {
  clergy: '/priests',
  events: '/events',
  news: '/news',
  parishes: '/parishes',
  archdeaconries: '/archdeaconries',
  gallery: '/gallery',
  galleryByEvente: '/gallery/by-event',
  contact: '/contact',
  pastBishops: '/past-bishops', // May not exist yet
  retiredPriests: '/retired-priests', // May not exist yet
  videos: '/videos',
  carousel: '/carousel',
  diocesan: '/diocesan',
  birthdayCelebrants: '/birthdays/today',
  themes: '/theme',
  episcopalStaff: '/episcopal_office',
  subscribe: '/subscribe',
};

// API functions
export const fetchClergy = () => api.get(apiEndpoints.clergy);
export const fetchEvents = () => api.get(apiEndpoints.events);
export const fetchNews = () => api.get(apiEndpoints.news);
export const fetchNewsBySlug = (slug: string) => api.get(`${apiEndpoints.news}/${slug}`);
export const fetchParishes = () => api.get(apiEndpoints.parishes);
export const fetchArchdeaconries = () => api.get(apiEndpoints.archdeaconries);
export const fetchGallery = () => api.get(apiEndpoints.gallery);
export const fetchPastBishops = () => api.get(apiEndpoints.pastBishops);
export const fetchRetiredPriests = () => api.get(apiEndpoints.retiredPriests);
export const fetchEpiscopalStaff = () => api.get(apiEndpoints.episcopalStaff);
export const submitContactForm = (data: any) => api.post(apiEndpoints.contact, data);
export const fetchClergyBySlug = (slug: string) => api.get(`${apiEndpoints.clergy}/${slug}`);
export const fetchParishBySlug = (slug: string) => api.get(`${apiEndpoints.parishes}/${slug}`);
export const fetchArchdeaconryBySlug = (slug: string) => api.get(`${apiEndpoints.archdeaconries}/${slug}`);
export const fetchGalleryByEvents = (id: string) => api.get(`${apiEndpoints.galleryByEvente}/${id}`);
export const getEventBySlug = (slug: string) => api.get(`${apiEndpoints.events}/${slug}`);
export const fetchPastStreams = () => api.get(`${apiEndpoints.videos}`);
export const fetchCarousel = () => api.get(`${apiEndpoints.carousel}`);
export const fetchDiocesan = () => api.get(`${apiEndpoints.diocesan}`);
export const fetchBirthdayCelebrants = () => api.get(`${apiEndpoints.birthdayCelebrants}`);
export const fetchTheme = (year: number) => api.get(`${apiEndpoints.themes}/${year}`);
export const subscribe = (data: { email: string }) => api.post(apiEndpoints.subscribe, data);



export default api;
